import AtivosOrdemServico from "../../../ordem-servicos/add-ordem-servico/components/ativos-ordem-servico.component";

const AtivosOrcamentoServico = ({
  orcamentoServicoEntity,
  setOrcamentoServico,
  orcamentosServicos = [],
  isFechado,
  somenteLeitura = false,
}) => (
  <AtivosOrdemServico
    ordemServicoEntity={orcamentoServicoEntity}
    setOrdemServico={setOrcamentoServico}
    ordemServicos={orcamentosServicos}
    isFechado={isFechado}
    somenteLeitura={somenteLeitura}
  />
);

export default AtivosOrcamentoServico;
